var spruceArticle = {
	vote:function(dir, postid){
		this.runSuccess();
		var thedelta = (dir == 'up') ? 1 : -1;
		$.ajax({
			type: 'POST',
			url: ajaxfullurl,
			data: {
				'action': 'spruce_vote',
				'postid': postid,
				'delta' : thedelta,
			}, 
			success: function (result) {
				var cookieDate = new Date();
				cookieDate.setTime(cookieDate.getTime()+(30*24*60*60*1000));
				var myPath = window.location.pathname;
        document.cookie="voted=yes;expires="+cookieDate.toGMTString()+";path="+myPath;
				//console.log(result);
			},
			error: function () {
				//console.log("No vote.");
			}
		});
	},
	runSuccess:function(){
		$(".article-helpful-vote .helpful-buttons").fadeOut("400", function(){
			$(".helpful-heading").html("Thank you for your feedback.");
			$(".helpful-heading-parent").addClass("col-12").removeClass("col-4").css("text-align", "center");
		});
	}
}
var pullCookie = key=>((new RegExp((key || '=')+'=(.*?); ','gm')).exec(document.cookie+'; ') ||['',null])[1]
$(document).ready(function(){
	if(pullCookie('voted') === 'yes'){
		$(".article-helpful-vote").hide();
	}
})
.on("click", ".action--vote", function (e){
	e.preventDefault();
	var dir = $(this).data("vote");

	if (dir == 'up') {
		var contextData = {
			'widget': 'widget|article helpful|thumbs up|',
			};
			_dd('widget_interaction', contextData);
	} else if (dir == 'down') {
		var contextData = {
			'widget': 'widget|article helpful|thumbs down|',
			};
			_dd('widget_interaction', contextData);
	}

	var postid = parseInt($(this).parents(".article-helpful-vote").data("postid"));
	spruceArticle.vote(dir, postid);
})
;
